import { createSlice } from "@reduxjs/toolkit";
import { getLeadLevelsThunk, getCallStatusTypesThunk, getLeadManagementThunk, addNewAssigningLeadsThunk, updateUnAssigningLeadsThunk, getMyTaskThunk, getLeadHistoryThunk, updateLeadHistoryThunk, getLeadStatusTypesThunk, getHeadLevelEmployeeThunk, getLevelWiseEmployeesThunk, getIndividualUserTaskThunk, getUnAssignedEmployeeesThunk, addLevelEmployeesThunk, deleteLevelEmployeesThunk } from "./leadMangementThunk";

const initialState = {
    status: "idle",
    status1: "idle",
    status2: "idle",
    status3: "idle",
    status4: "idle",
    error: null,
    success: "",
    leadLevels: [],
    callStatusTypes: [],
    leadStatusTypes: [],
    getLeadManagementLeads: [],
    getMyTaskDetails: [],
    getLeadHistory: [],
    getHeadLevelEmployees: [],
    getLevelWiseEmployees: [],
    getIndividualUserTaskDetails: [],
    openLeadChatConvo: false,
    getUnAssignedEmployees: [],
};

const leadManagementSlice = createSlice({
    name: "leadManagement",
    initialState,
    reducers: {
        setResetEmployees: (state, action) => {
            state.getLevelWiseEmployees = [];
        },
        setOpenLeadChatConvo: (state, action) => {
            state.openLeadChatConvo = action.payload;
        },
        resetLeadManagementState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
            state.getUnAssignedEmployees = [];
            state.getHeadLevelEmployees = [];
        }
    },
    extraReducers: (builder) => {
        builder
            // LEVELS
            .addCase(getLeadLevelsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getLeadLevelsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.leadLevels = action.payload;
            })
            .addCase(getLeadLevelsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Levels failed";
                state.success = "";
            })

            // CALL STATUS TYPES
            .addCase(getCallStatusTypesThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getCallStatusTypesThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.callStatusTypes = action.payload;
            })
            .addCase(getCallStatusTypesThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "call status type has failed";
                state.success = "";
            })

            // getLeadManagementLeads
            .addCase(getLeadManagementThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getLeadManagementThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getLeadManagementLeads = action.payload;
            })
            .addCase(getLeadManagementThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Leads failed";
                state.success = "";
            })

            // create new assigning leads
            .addCase(addNewAssigningLeadsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addNewAssigningLeadsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addNewAssigningLeadsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "new assigning is failed";
                state.success = "";
            })

            // Add the DepartmentThunk
            .addCase(updateUnAssigningLeadsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(updateUnAssigningLeadsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(updateUnAssigningLeadsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Update unassigning is failed";
                state.success = "";
            })


            // /get My Task Details
            .addCase(getMyTaskThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getMyTaskThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getMyTaskDetails = action.payload || [];
            })
            .addCase(getMyTaskThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "lead task failed";
                state.success = "";
            })

            // Get Lead History
            .addCase(getLeadHistoryThunk.pending, (state) => {
                state.status1 = "loading";
                state.error = null;
            })
            .addCase(getLeadHistoryThunk.fulfilled, (state, action) => {
                state.status1 = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getLeadHistory = action.payload || [];
            })
            .addCase(getLeadHistoryThunk.rejected, (state, action) => {
                state.status1 = "failed";
                state.error = action.payload || "Levels failed";
                state.success = "";
            })


            //updateLeadHistoryThunk 
            .addCase(updateLeadHistoryThunk.pending, (state) => {
                state.status2 = "loading";
                state.error = null;
            })
            .addCase(updateLeadHistoryThunk.fulfilled, (state, action) => {
                state.status2 = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(updateLeadHistoryThunk.rejected, (state, action) => {
                state.status2 = "failed";
                state.error = action.payload || "Update Lead History failed";
                state.success = "";
            })


            // Lead Status Types
            .addCase(getLeadStatusTypesThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getLeadStatusTypesThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.leadStatusTypes = action.payload;
            })
            .addCase(getLeadStatusTypesThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Levels failed";
                state.success = "";
            })



            // Lead Status Types
            .addCase(getHeadLevelEmployeeThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getHeadLevelEmployeeThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getHeadLevelEmployees = action.payload?.data || [];
            })
            .addCase(getHeadLevelEmployeeThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Levels failed";
                state.success = "";
            })


            // Level Wise Employes
            .addCase(getLevelWiseEmployeesThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getLevelWiseEmployeesThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getLevelWiseEmployees = action.payload?.data || [];
            })
            .addCase(getLevelWiseEmployeesThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Levels failed";
                state.success = "";
            })



            // getIndividualUserTaskThunk
            .addCase(getIndividualUserTaskThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getIndividualUserTaskThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getIndividualUserTaskDetails = action.payload || [];
            })
            .addCase(getIndividualUserTaskThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Levels failed";
                state.success = "";
            })


            // UN ASSIGNED EMPLOYEES 
            .addCase(getUnAssignedEmployeeesThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getUnAssignedEmployeeesThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.getUnAssignedEmployees = action.payload;
            })
            .addCase(getUnAssignedEmployeeesThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Levels failed";
                state.success = "";
            })




            // create new assigning leads
            .addCase(addLevelEmployeesThunk.pending, (state) => {
                state.status3 = "loading";
                state.error = null;
            })
            .addCase(addLevelEmployeesThunk.fulfilled, (state, action) => {
                state.status3 = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addLevelEmployeesThunk.rejected, (state, action) => {
                state.status3 = "failed";
                state.error = action.payload || "Employee Adding failed";
                state.success = "";
            })


            // DELETE EMPLOYEE THUNKS
            .addCase(deleteLevelEmployeesThunk.pending, (state) => {
                state.status4 = "loading";
                state.error = null;
            })
            .addCase(deleteLevelEmployeesThunk.fulfilled, (state, action) => {
                state.status4 = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(deleteLevelEmployeesThunk.rejected, (state, action) => {
                state.status4 = "failed";
                state.error = action.payload || "Employee Delete failed";
                state.success = "";
            })
    },
});

export const { setResetEmployees, resetLeadManagementState, setOpenLeadChatConvo } = leadManagementSlice.actions;
export default leadManagementSlice.reducer;